import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { RouterLink } from "@remo-co/ui-core/src/components/RouterLink";
import useAuthNavigation from "./hooks/useAuthNavigation";

const NavigateToSignUp = () => {
  const { t } = useI18n(["auth"]);
  const url = useAuthNavigation("signup");

  return (
    <Typography component="span" color="textSecondary">
      {t("auth:account.not.exist")}{" "}
      <RouterLink to={url} noUnderline>
        <Typography color="textPrimary" component="span">
          {t("auth:sign.up")}{" "}
        </Typography>
      </RouterLink>
      <br />
    </Typography>
  );
};

export default NavigateToSignUp;
